import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useStore } from './store';
import { ChatPanel } from './components/ChatPanel';
import { Sidebar } from './components/Sidebar';
import { SettingsPanel } from './components/SettingsPanel';
import { VideoModal } from './components/VideoModal';

export default function App() {
  const { activePanel, previewUrl } = useStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-surface-0 text-text-primary overflow-hidden">
      {/* Mobile sidebar toggle */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="fixed top-4 left-4 z-50 p-2 bg-surface-2 border border-border rounded-lg lg:hidden"
      >
        {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed lg:relative z-40 transition-transform duration-300 ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        {activePanel === 'chat' && <ChatPanel />}
        {activePanel === 'settings' && <SettingsPanel />}
      </div>

      {/* Video preview modal */}
      {previewUrl && <VideoModal />}
    </div>
  );
}